module.exports = __webpack_public_path__ + "img/cy.f0e2665.svg";